import src from "IMAGE";
export default { src, width: 4476, height: 3680, blurWidth: 8, blurHeight: 7, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAYAAAA1WQxeAAAAKUlEQVR42r2KsQ0AAAjCiv8fbTQuDsTNLhAKAgJVLGrTFBztvB73cLhIELcAGQS8sYUAAAAASUVORK5CYII="};
